/**
 * EastDTC — Canvas 尺寸测量与标签页休眠恢复（全站 Canvas 动画共用）
 */
(function (global) {
  'use strict';

  function measureElementSize(el, options) {
    if (!el) return { width: 1, height: 1 };

    var opts = options || {};
    var minW = opts.minWidth != null ? opts.minWidth : 80;
    var minH = opts.minHeight != null ? opts.minHeight : 80;
    var useViewportW = opts.fallbackViewportWidth !== false;
    var viewportHRatio = opts.fallbackViewportHeightRatio;

    var rect = el.getBoundingClientRect();
    var w = Math.floor(rect.width);
    var h = Math.floor(rect.height);

    if (w < 2) w = el.offsetWidth || 0;
    if (h < 2) h = el.offsetHeight || 0;

    if (w < 2 && el.parentElement) {
      var p = el.parentElement;
      w = Math.floor(p.getBoundingClientRect().width) || p.offsetWidth || 0;
    }
    if (h < 2 && el.parentElement) {
      var parent = el.parentElement;
      h = Math.floor(parent.getBoundingClientRect().height) || parent.offsetHeight || 0;
    }

    if (!document.hidden) {
      if (useViewportW && w < minW) {
        w = Math.max(w, Math.floor(window.innerWidth));
      }
      if (viewportHRatio && h < minH) {
        h = Math.max(h, Math.floor(window.innerHeight * viewportHRatio));
      } else if (h < minH && opts.squareFromWidth && w >= minW) {
        h = Math.max(h, w);
      }
    }

    return {
      width: Math.max(1, w),
      height: Math.max(1, h)
    };
  }

  /** 优先用 canvas 实际渲染尺寸（与 CSS 100% 一致），避免休眠后逻辑尺寸与显示脱节 */
  function measureCanvasSize(canvas, container, options) {
    if (!canvas) return { width: 1, height: 1 };

    var opts = options || {};
    var minW = opts.minWidth != null ? opts.minWidth : 2;
    var minH = opts.minHeight != null ? opts.minHeight : 2;
    var cw = Math.floor(canvas.clientWidth);
    var ch = Math.floor(canvas.clientHeight);

    if (cw >= minW && ch >= minH) {
      return { width: cw, height: ch };
    }

    return measureElementSize(container || canvas.parentElement, opts);
  }

  function canvasNeedsResize(canvas, logicalW, logicalH, dpr) {
    if (!canvas || logicalW < 1 || logicalH < 1) return true;

    var ratio = dpr || 1;
    var cw = Math.floor(canvas.clientWidth);
    var ch = Math.floor(canvas.clientHeight);

    if (cw < 2 || ch < 2) return false;

    var backingW = Math.round(canvas.width / ratio);
    var backingH = Math.round(canvas.height / ratio);

    return (
      Math.abs(cw - logicalW) > 2 ||
      Math.abs(ch - logicalH) > 2 ||
      Math.abs(cw - backingW) > 2 ||
      Math.abs(ch - backingH) > 2
    );
  }

  function applyCanvasDisplaySize(canvas) {
    if (!canvas) return;
    canvas.style.width = '100%';
    canvas.style.height = '100%';
    canvas.style.maxWidth = 'none';
    canvas.style.maxHeight = 'none';
    canvas.style.left = '';
    canvas.style.top = '';
    canvas.style.right = '';
    canvas.style.bottom = '';
    canvas.removeAttribute('width');
    canvas.removeAttribute('height');
  }

  /**
   * @param {function(boolean)} onLayout — false=防抖调度, true=标签恢复后同步
   */
  function createLayoutScheduler(onLayout) {
    var layoutTimer = null;
    var retryTimers = [];

    function clearRetries() {
      retryTimers.forEach(function (id) {
        window.clearTimeout(id);
      });
      retryTimers = [];
    }

    function schedule() {
      if (document.hidden) return;
      if (layoutTimer) window.clearTimeout(layoutTimer);
      layoutTimer = window.setTimeout(function () {
        layoutTimer = null;
        onLayout(false);
      }, 80);
    }

    function syncWhenVisible() {
      if (layoutTimer) {
        window.clearTimeout(layoutTimer);
        layoutTimer = null;
      }
      clearRetries();

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            onLayout(true);
            [50, 200, 500, 1200].forEach(function (delay) {
              retryTimers.push(
                window.setTimeout(function () {
                  if (!document.hidden) onLayout(false);
                }, delay)
              );
            });
          });
        });
      });
    }

    function bindLifecycle(opts) {
      opts = opts || {};
      var onHidden = opts.onHidden;
      var onVisible = opts.onVisible;

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          clearRetries();
          if (onHidden) onHidden();
        } else if (onVisible) {
          onVisible();
        } else {
          syncWhenVisible();
        }
      });

      window.addEventListener('pageshow', function () {
        if (onVisible) onVisible();
        else syncWhenVisible();
      });

      window.addEventListener('focus', function () {
        if (!document.hidden) schedule();
      });
    }

    return {
      schedule: schedule,
      syncWhenVisible: syncWhenVisible,
      bindLifecycle: bindLifecycle,
      clearRetries: clearRetries
    };
  }

  global.EastDtcCanvasResize = {
    measureElementSize: measureElementSize,
    measureCanvasSize: measureCanvasSize,
    canvasNeedsResize: canvasNeedsResize,
    createLayoutScheduler: createLayoutScheduler,
    applyCanvasDisplaySize: applyCanvasDisplaySize
  };
})(typeof window !== 'undefined' ? window : this);
